import { INearbyPatient } from "@home-health-notify/domain";
import { darken } from "@mui/material";
import {
  convertMilesToMeters,
  DISTANCE_IN_MILES,
  // Re-export shared utilities from commons
  DEFAULT_ZOOM,
  ZOOM_LEVELS,
  MARKER,
  PatientsLocationDataType,
  getNearbyPatientsLocationData,
  StatusColor,
  getGroupPatientStatusColor as getGroupPatientStatusColorBase,
  isAddressEmpty,
  getAdvanceSearchFilters,
  getPatientHeaderProps,
} from "hhn-commons";
import theme from "../../../../theme";

// Re-export shared utilities for backwards compatibility
export {
  DEFAULT_ZOOM,
  ZOOM_LEVELS,
  MARKER,
  getNearbyPatientsLocationData,
  isAddressEmpty,
  getAdvanceSearchFilters,
  getPatientHeaderProps,
};
export type { PatientsLocationDataType, StatusColor };

// Web-specific constants
export const mapElement = "nearby-patients-map";
export const mapID = "advance-search-map";

// Web-specific: Mixed status color using MUI's darken
export const mixStatusColor = darken(
  theme.message?.visibleToPatient as string,
  0.2,
);

/**
 * Web-specific wrapper that provides the mixStatusColor
 */
export function getGroupPatientStatusColor(
  patients: INearbyPatient[],
): StatusColor {
  return getGroupPatientStatusColorBase(patients, mixStatusColor);
}

/**
 * Web-specific: Fits a circle on Google Maps based on distance
 */
export const fitCircleOnMap = (
  map: google.maps.Map,
  selectedDistance: DISTANCE_IN_MILES,
  position: google.maps.LatLngLiteral,
  setCircleRadius: (radius: number) => void,
): void => {
  const radiusInMeters = convertMilesToMeters(selectedDistance);
  const circle = new google.maps.Circle({
    center: position,
    radius: radiusInMeters,
  });
  const circleBounds = circle.getBounds();
  circleBounds && map.fitBounds(circleBounds);
  map.setCenter(position);
  setCircleRadius(radiusInMeters);
};
